<div class="panic-control-container display-flex-column">
    <button mat-icon-button
            class="close-icon-btn outline"
            (click)="close()">
        <mat-icon>close</mat-icon>
    </button>

    <div class="text-center">
        <div class="font-28 font-bold pad-8">
            <span>Panic Control</span>
        </div>
    </div>
    <div class="pad-8">
        <div class="flex-space-between margin-top">
            <div class="info-text">
                <p class="no-margin star-color font-inter-medium">
                    {{ PANIC_CONTROL_PAUSE_TEXT }}
                </p>
                <p class="margin-8-top margin-bottom">
                    <span class="font-bold">Note: </span>
                    You can only pause your self created strategies.
                </p>
            </div>
            <div class="action-btn">
                <button mat-button
                        class="star-color-bg text-primary-contrast focus-out-btn outline"
                        (click)="pauseAll()">
                    Pause All
                </button>
            </div>
        </div>

        <div class="border-bottom">

        </div>

        <div class="flex-space-between margin-24-top">
            <div class="info-text">
                <p class="no-margin text-negative font-inter-medium" [innerHtml]="PANIC_CONTROL_STOP_TEXT">
                </p>
            </div>
            <div class="action-btn">
                <button mat-button
                        class="bg-negative text-primary-contrast focus-out-btn outline"
                        (click)="stopAll()">
                    Stop All
                </button>
            </div>
        </div>
    </div>
</div>
